import React from 'react';
import ShortForm from './ShortForm';
import Page from './Page';
import Tooltips from './Tooltips';
import _ from 'lodash';
import scrollToElement from 'scroll-to-element';


export default class Tips extends Page {

	componentDidMount() {
		this.jumpToHash();
	}
	
	componentDidUpdate(prevProps) {
		this.jumpToHash();
	}
	
	jumpToHash = () => {
		const hash = window.location.hash;
		if (hash) {
			scrollToElement(hash, { offset: -120 });
		}
	}

	render(){
		return (
			<ShortForm
				label='How To Use Venkman'
				formWidth='medium'
				>
				{_.map(Tooltips.tips, (tip, key) => (
					<Tooltips.Content key={key} id={key} outerClass="tip-as-list-item" showLink={false} />
				))}
			</ShortForm>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Tips.js